<div class="exp-panel" [class.is-busy]="busy">
  <section class="exp-section">
    <h6 class="exp-head">{{ 'cv.tailor.inclusion.sectionEducation' | translate }} &middot; {{ included.length }}</h6>
    @for (e of included; track e.edu_id) {
      <div class="edu-row">
        <div class="edu-line">
          <span class="exp-dot included"></span>
          <div class="exp-main">
            <span class="exp-title">{{ e.degree }}@if (e.role) { <span class="exp-emp">&middot; {{ e.role }}</span> }</span>
            <span class="exp-dates">{{ e.employer }} &middot; {{ e.dates }}</span>
          </div>
          <div class="edu-actions">
            @if (e.description) {
              <button nbButton ghost size="tiny" status="basic" type="button" [disabled]="busy" (click)="toggleShow(e)">
                {{ (e.show_description ? 'cv.tailor.inclusion.hideDescription' : 'cv.tailor.inclusion.showDescription') | translate }}
              </button>
              <!-- Editing the description text is NOT a #1420 affordance: it
                   predates the flag and its endpoint is not flag-gated. Only
                   the route differs — the shared field editor when manual
                   editing is on, this panel's own inline textarea (the
                   pre-#1420 control, below) when it is off. -->
              @if (e.show_description) {
                <button nbButton ghost size="tiny" status="basic" type="button" [disabled]="busy"
                        (click)="manualEdit
                          ? editDescription.emit({ eduId: e.edu_id, label: e.degree, current: e.description })
                          : startEdit(e)">
                  {{ 'cv.tailor.inclusion.editDescription' | translate }}
                </button>
              }
            }
            @if (manualEdit) {
              <button nbButton ghost size="tiny" status="basic" type="button" [disabled]="busy || disabled"
                      (click)="editField.emit({ field: 'education_text', educationId: e.edu_id, edField: 'degree', label: e.employer, current: e.degree })">
                {{ 'cv.tailor.edit.editDegree' | translate }}
              </button>
              <button nbButton ghost size="tiny" status="basic" type="button" [disabled]="busy || disabled"
                      (click)="editField.emit({ field: 'education_text', educationId: e.edu_id, edField: 'role', label: e.employer, current: e.role })">
                {{ 'cv.tailor.edit.editStudy' | translate }}
              </button>
              <button nbButton ghost size="tiny" status="basic" type="button" [disabled]="busy || disabled"
                      (click)="editField.emit({ field: 'education_text', educationId: e.edu_id, edField: 'employer', label: e.employer, current: e.employer })">
                {{ 'cv.tailor.edit.editInstitution' | translate }}
              </button>
              <button nbButton ghost size="tiny" status="basic" type="button" [disabled]="busy || disabled"
                      (click)="editField.emit({ field: 'period', section: 'education', id: e.edu_id, label: e.degree || e.role, start: e.start, end: e.end })">
                {{ 'cv.tailor.edit.editDates' | translate }}
              </button>
            }
            <button nbButton ghost size="tiny" status="basic" type="button" [disabled]="busy || disabled" (click)="setAside.emit(e.edu_id)">
              {{ 'cv.tailor.inclusion.setAside' | translate }}
            </button>
          </div>
        </div>
        @if (editingId === e.edu_id) {
          <div class="edu-edit">
            <textarea nbInput fullWidth rows="4" maxlength="2000" [(ngModel)]="draft" [disabled]="busy"></textarea>
            <div class="edu-edit-actions">
              <button nbButton size="tiny" status="primary" type="button" [disabled]="busy" (click)="saveEdit(e)">
                {{ 'cv.tailor.inclusion.saveDescription' | translate }}
              </button>
              <button nbButton ghost size="tiny" status="basic" type="button" [disabled]="busy" (click)="cancelEdit()">
                {{ 'cv.tailor.inclusion.cancel' | translate }}
              </button>
            </div>
          </div>
        } @else if (e.show_description && e.description) {
          <div class="edu-desc">{{ e.description }}</div>
        }
      </div>
    }
  </section>

  @if (setAsideList.length > 0) {
    <section class="exp-section">
      <h6 class="exp-head">{{ 'cv.tailor.inclusion.setAsideHead' | translate }} &middot; {{ setAsideList.length }}</h6>
      @for (e of setAsideList; track e.edu_id) {
        <div class="exp-row">
          <span class="exp-dot aside"></span>
          <div class="exp-main">
            <span class="exp-title">{{ e.degree }}@if (e.role) { <span class="exp-emp">&middot; {{ e.role }}</span> }</span>
            <span class="exp-dates">{{ e.employer }} &middot; {{ e.dates }}</span>
            @if (e.reason) { <span class="exp-reason">{{ e.reason }}</span> }
          </div>
          <button nbButton ghost size="tiny" status="primary" type="button" [disabled]="busy || disabled" (click)="restore.emit(e.edu_id)">
            {{ 'cv.tailor.inclusion.restore' | translate }}
          </button>
        </div>
      }
    </section>
  }
</div>
